// components/Events/DamageEvent.tsx

import React, { useContext } from 'react';
import { BaseRendererProps } from './eventRenderers';
import { getDamageTypeIcon, getCritDamageTypeIcon } from './utils';
import './DamageEvent.css';
import GameAssetsContext from '../../../../../../context/GameAssetContext';
import { itemNameToId } from '../../../../../../mappings/itemMappings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTurnUp } from '@fortawesome/free-solid-svg-icons';
import debuffImages from './Images/debuffImages';
import { championImages } from './Images/championImages';
import { getUniversalSourceIcon } from './StatChangeEvent';

const DamageEvent: React.FC<BaseRendererProps> = ({ log }) => {
  const { gameWideAssets, championsAssets } = useContext(GameAssetsContext);
  const { itemImages, runes, critIcons } = gameWideAssets;

  const details = log.details;
  const damageAmount = Math.floor(details.damageAmount || 0);
  const isCrit = details.isCrit || false;
  const damageSubType = details.damageSubType;
  const sourceType = details.sourceType || 'Ability';
  const sourceName = details.source;
  const imageState = log.imageState;
  const abilityKey = details.spellKey;
  const attackerName = details.attackerName;
  const petName = details.petName; // For pet damage sources

  const autoAttackImageUrl = championsAssets[attackerName]?.autoAttackImageUrl;

  // Determine the damage icon based on whether it's a crit
  let damageIcon = null;
  if (isCrit) {
    damageIcon = getCritDamageTypeIcon(damageSubType, critIcons);  
  } else {
    damageIcon = getDamageTypeIcon(damageSubType);
  }

  // Use the new universal image fetcher for source icon
  const sourceIcon = getUniversalSourceIcon(
    {
      sourceType: sourceType,
      imageState: imageState,
      sourceName: sourceName,
      championName: attackerName,
      abilityKey: abilityKey || imageState,
      petName: petName, // Pass pet name for pet damage
    },
    gameWideAssets,
    championsAssets
  );

  return (
    <div className="damage-event">
      <div className="damage-amount-wrapper">
        {damageIcon}
        <span className="damage-amount">{damageAmount}</span>
      </div>
      {sourceIcon && (
        <div className="damage-source-wrapper">
          <FontAwesomeIcon icon={faTurnUp} className="fa-turn-up" />
          {sourceIcon}
        </div>
      )}
    </div>
  );
};

export default DamageEvent;
